<template slot-scope="scope">
      <dialogModel
        title="详情"
        :visible.sync="dialogIMGDetails"
        :footer="false"
        @handleClose="handleCancel"
      >
        <div>
          <div class="carousel_box">
            <el-carousel :interval="6000" arrow="always">
              <el-carousel-item v-for="item in IMGdata" :key="item.id">
                <img :src="item.docPath" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="View-Sign firm-clickable" v-if="ViewSign==0||ViewSign==1" @click="handelViewSign">签订/下载</div>
        </div>
      </dialogModel>
</template>

<script>
export default {
  props: {
    dialogIMGDetails: {},
    IMGdata: {}, //数据
    ViewSign:{},//是否显示签订/下载
  },
  components: {},
  data() {
    return {
      imgArr: [
        {
          id: "1",
          // image: require("@/assets/imgs/img/1747807888329.jpg"),
        },
        {
          id: "2",
          // image: require("@/assets/imgs/img/1747807865213.jpg"),
        },
      ], // 轮播图数据列表
    };
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    // 取消
    handleCancel() {
      // console.log(this.IMGdata)
      this.$emit("handleCancel");
    },
    handelViewSign(){
      this.$emit("handelViewSign");
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-carousel__indicators {
  display: none !important;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.carousel_box {
  width: 100%;
  min-height: 760px;
  padding-top: 0px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  border-radius: 10px;
  img {
    border-radius: 10px;
  }
  /deep/.el-carousel__container {
    min-height: 700px !important;
    border-radius: 10px;
  }
  .View-Sign {
    width: 100px;
    height: 25px;
    line-height: 25px;
    background-color: #409eff ;
    border-radius: 5px;
    text-align: center;
    color: aliceblue;
    font-size: 12px;
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
</style>
